'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorialLabel = function EditorialLabel(_ref) {
    var theme = _ref.theme;
    var label = _ref.label;

    if (label.length === 0) {
        return null;
    }

    return _react2.default.createElement(
        'div',
        { className: theme['editorial-label'] },
        _react2.default.createElement(
            'span',
            null,
            label
        )
    );
};

EditorialLabel.defaultProps = {
    label: ''
};

EditorialLabel.propTypes = {
    label: _propTypes2.default.string,
    theme: _propTypes2.default.shape({
        'editorial-label': _propTypes2.default.string
    }).isRequired
};

exports.default = EditorialLabel;
//# sourceMappingURL=EditorialLabel.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/editorial-label/lib/cjs/EditorialLabel.js
 ** module id = 719
 ** module chunks = 1
 **/